<div *transloco="let t">
	<vex-page-layout mode="card">
		<vex-page-layout-header class="pb-16 flex flex-col justify-center items-start">
			<div>
				<h1 class="title mt-0 mb-1" name="settingsTitle">{{ t('permissions.permissions') }}</h1>
				<vex-breadcrumbs [crumbs]="this.breadCrumbService.crumbs"></vex-breadcrumbs>
			</div>
		</vex-page-layout-header>
		<vex-page-layout-content [class.container]="false" [class.px-gutter]="true" class="-mt-6">
			<div class="card overflow-auto -mt-16">
				<div class="card p-6">
					<div @stagger class="mb-2" vexContainer>
						@if (permissions.length <= 0) {
							<div class="my-4">
								<h3 class="text-muted">{{ t('permissions.noPermission') }}</h3>
							</div>
						}
						@if (permissions.length > 0) {
							<div>
								<table @stagger [dataSource]="dataSource" class="w-full" mat-table>
									<ng-container matColumnDef="code">
										<th *matHeaderCellDef mat-header-cell>
											{{ t('permissions.code') }}
										</th>
										<td *matCellDef="let permissionEntity" [attr.data-label]="t('permissions.code')" mat-cell>
											{{ permissionEntity.permission.authCode }}
										</td>
									</ng-container>

									<ng-container matColumnDef="activatedOn">
										<th *matHeaderCellDef mat-header-cell>
											{{ t('permissions.redeemDate') }}
										</th>
										<td *matCellDef="let permissionEntity" [attr.data-label]="t('permissions.redeemDate')" mat-cell>
											{{ permissionEntity.permission.codeActivatedOn | date: 'dd.MM.yyyy HH:mm:ss' }}
										</td>
									</ng-container>

									<ng-container matColumnDef="permission">
										<th *matHeaderCellDef mat-header-cell>
											{{ t('permissions.permission') }}
										</th>
										<td *matCellDef="let permissionEntity" [attr.data-label]="t('permissions.permission')" mat-cell>
											<div class="flex flex-row text-ellipsis">
												{{ permissionsService.permissionTypeToReadable(permissionEntity.permission.permissionType) }}
												@if (permissionEntity.permission.permissionType === 'PROPERTY_MANAGEMENT') {
													({{ permissionEntity.propertyManagement }})
												} @else {
													({{
														permissionEntity.street
															? permissionEntity.street
															: '' + permissionEntity.zip
																? ', ' + permissionEntity.zip
																: '' + permissionEntity.city
																	? ' ' + permissionEntity.city
																	: ''
													}})
												}
											</div>
										</td>
									</ng-container>

									<ng-container matColumnDef="activatedBy">
										<th *matHeaderCellDef mat-header-cell>
											{{ t('permissions.codeActivatedBy') }}
										</th>
										<td *matCellDef="let permissionEntity" [attr.data-label]="t('permissions.codeActivatedBy')" mat-cell>
											<div class="flex flex-row gap-1">
												{{ permissionEntity.creator }}
												@if (permissionEntity.creator === sessionService.keycloakUsername) {
													<mat-icon [svgIcon]="icons.get('person')" [matTooltip]="t('permissionStages.you')"></mat-icon>
												}
											</div>
										</td>
									</ng-container>

									<ng-container matColumnDef="serviceCompany">
										<th *matHeaderCellDef mat-header-cell>
											{{ t('permissions.serviceCompany') }}
										</th>
										<td *matCellDef="let permissionEntity" [attr.data-label]="t('permissions.serviceCompany')" mat-cell>
											<div>
												{{ permissionEntity?.permission?.area ? getServiceCompanyName(permissionEntity.permission.area) : '' }}
												<div class="flex flex-row whitespace-pre-wrap">
													@for (policy of tablePolicies.get(permissionEntity.permission.area); track policy.type) {
														<a class="text-link" (click)="showPolicy(policy, permissionEntity?.permission?.area)">
															{{ t('policy.' + policy.type + '.name') }}
														</a>
													}
												</div>
											</div>
										</td>
									</ng-container>

									<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
									<tr
										*matRowDef="let row; columns: displayedColumns"
										mat-row
										@fadeInUp
										class="hover:bg-hover trans-ease-out cursor-pointer"
										name="permissionRow"></tr>
								</table>
							</div>
						}
					</div>
				</div>
			</div>
		</vex-page-layout-content>

		@if (activeTab === 0) {
			<vex-page-layout-content @fadeInUp @stagger class="my-2" vexContainer>
				<div class="card p-6">
					<div class="flex flex-row">
						<div class="flex flex-row w-[40%]" style="align-items: center">
							<h2 class="margin-left-20">{{ t('permissions.addPermission') }}</h2>
						</div>
					</div>
					<div class="flex flex-row items-center">
						<mat-form-field appearance="outline" style="width: 50%; max-width: 400px" subscriptSizing="dynamic">
							<mat-label>{{ t('permissions.code') }}</mat-label>
							<input
								[formControl]="codeLength"
								class="permission-code-input"
								matInput
								name="authCodeInput"
								oninput="this.value = this.value.toUpperCase()"
								placeholder="{{ t('permissions.code') }}" />
							<mat-error name="authCodeError">
								{{ errorMsg }}
							</mat-error>
						</mat-form-field>
						<div class="flex items-center justify-end">
							<ara-spinner-button
								[action]="addPermission.bind(this)"
								[disabledWhenSpinning]="true"
								[hideTextOnMobile]="true"
								[showSpinner]="authCodeIsBeingChecked()"
								[svgIcon]="icons.get('keyAdd')"
								buttonText="{{ t('permissions.checkCode') }}"
								name="checkCodeButton"></ara-spinner-button>
						</div>
					</div>
				</div>
			</vex-page-layout-content>
			<vex-page-layout-content @fadeInUp @stagger vexContainer>
				<div class="card p-6">
					@if (!layoutService.isMobile()) {
						<div class="section-header mb-6">
							<h2 class="section-title">{{ t('permissions.missingCode') }}</h2>
						</div>
						<div class="flex flex-row justify-center">
							<div class="info-text flex flex-col">
								<h3 class="subsection-title">{{ t('permissions.propertymanagementHeadline') }}</h3>
								{{ t('permissions.propertymanagementText') }}
							</div>
							<div class="info-text flex flex-col">
								<h3 class="subsection-title">{{ t('permissions.tenantHeadline') }}</h3>
								<span [innerHTML]="t('permissions.tenantText', { araAppUrl })"></span>
							</div>
							<div class="info-text flex flex-col">
								<h3 class="subsection-title">{{ t('permissions.ownerHeadline') }}</h3>
								{{ t('permissions.ownerText') }}
							</div>
						</div>
					}
					@if (layoutService.isMobile()) {
						<div class="section-header mb-6">
							<h2 class="section-title">{{ t('permissions.missingCode') }}</h2>
						</div>
						<div class="flex flex-row justify-center items-center">
							<div class="flex flex-col justify-center items-center">
								<swiper-container autoplay="2000" class="slide-box" loop="true" slides-per-view="1" pagination="true" speed="500">
									<swiper-slide>
										<div class="info-text">
											<h3 class="subsection-title">{{ t('permissions.propertymanagementHeadline') }}</h3>
											{{ t('permissions.propertymanagementText') }}
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="info-text">
											<h3 class="subsection-title">{{ t('permissions.ownerHeadline') }}</h3>
											{{ t('permissions.ownerText') }}
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="info-text">
											<h3 class="subsection-title">{{ t('permissions.tenantHeadline') }}</h3>
											<span [innerHTML]="t('permissions.tenantText', { araAppUrl })"></span>
										</div>
									</swiper-slide>
								</swiper-container>
							</div>
						</div>
					}
				</div>
			</vex-page-layout-content>
		}
	</vex-page-layout>
</div>
